import type { CargaProfissionaisProps } from "./types-carga-profissionais";
import { useCargaProfissionais } from "./use-carga-profissionais";
import { CargaProfissionaisView } from "./view-carga-profissionais";

export function CargaProfissionais(props: CargaProfissionaisProps) {
  const vm = useCargaProfissionais(props);

  return <CargaProfissionaisView {...vm} />;
}

export type * from "./types-carga-profissionais";
